import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";

const ManageView = ({ setJobsView, currentItem }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[96vh] overflow-y-auto	">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("VIEW_MANAGE_JOBS")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => setJobsView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job title</strong>
                      <h6>{currentItem.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Country</strong>
                      <h6>{currentItem.Country?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>State</strong>
                      <h6>{currentItem?.State?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{currentItem?.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Category</strong>
                      <h6>{currentItem.Category?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Subcategory</strong>
                      <h6>{currentItem.subCategory?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Created date</strong>
                      <h6>{dayjs(currentItem?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Department</strong>
                      <h6>{currentItem?.Department?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employment length (In days)</strong>
                      <h6>{startCase(currentItem.employmentLength || "")}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Skills</strong>
                      <h6>{currentItem.Skills?.map((item) => item?.name).join(", ") || ""}</h6>
                    </div>
                  </div>

                  {/* NEW: Broadbean budget/duration (read-only) */}
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Budget</strong>
                      <h6>{currentItem?.budget ? `$${currentItem.budget}` : ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Duration</strong>
                      <h6>{currentItem?.duration ? `${currentItem.duration} days` : ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
  <div className="relative z-0 mb-2 w-full group">
    <strong>Daily rate</strong>
    <h6>{currentItem?.dailyRate ? `$${currentItem.dailyRate}/day` : ""}</h6>
  </div>
</div>
<div className="sm:py-4 sm:px-2 py-8 px-7">
  <div className="relative z-0 mb-2 w-full group">
    <strong>Billed this cycle</strong>
    <h6>{currentItem?.budgetChargedAmount ? `$${currentItem.budgetChargedAmount}` : ""}</h6>
  </div>
</div>
{currentItem?.deferredAmount > 0 && (
  <div className="sm:py-4 sm:px-2 py-8 px-7">
    <div className="relative z-0 mb-2 w-full group">
      <strong>Deferred to next cycle</strong>
      <h6>${currentItem.deferredAmount}</h6>
    </div>
  </div>
)}
                </div>
                <div className="grid">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job description</strong>
                      <div className="inner-html" style={{paddingLeft:"17px"}} dangerouslySetInnerHTML={{ __html: currentItem.description }} />
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Termination condition</strong>
                      <div className="inner-html" style={{paddingLeft:"17px"}} dangerouslySetInnerHTML={{ __html: currentItem.terminationCondition }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setJobsView(false)}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default ManageView;





// import React from "react";
// import { useTranslation } from "react-i18next";
// import dayjs from "dayjs";
// import { startCase } from "lodash";

// const ManageView = ({ setJobsView, currentItem }) => {
//   const { t } = useTranslation();
//   return (
//     <>
//       <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
//         <div className="relative w-auto my-6 mx-auto max-w-3xl">
//           <form className="sm:py-4 sm:px-2 py-8 px-7">
//             <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[96vh] overflow-y-auto	">
//               <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
//                 <h3 className="text-xl font-semibold">{t("VIEW_MANAGE_JOBS")}</h3>
//                 <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => setJobsView(false)}>
//                   <span className=" text-[#B8BBBF]  text-4xl " title="Close">
//                     ×
//                   </span>
//                 </button>
//               </div>
//               <div className="relative p-6 flex-auto">
//                 <div className="grid grid-cols-3">
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Job title</strong>
//                       <h6>{currentItem.name || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Country</strong>
//                       <h6>{currentItem.Country?.name || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>State</strong>
//                       <h6>{currentItem?.State?.name || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>City</strong>
//                       <h6>{currentItem?.city || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Category</strong>
//                       <h6>{currentItem.Category?.name || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Subcategory</strong>
//                       <h6>{currentItem.subCategory?.name || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Created date</strong>
//                       <h6>{dayjs(currentItem?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Department</strong>
//                       <h6>{currentItem?.Department?.name || ""}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Employment length (In days)</strong>
//                       <h6>{startCase(currentItem.employmentLength || "")}</h6>
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Skills</strong>
//                       <h6>{currentItem.Skills?.map((item) => item?.name).join(", ") || ""}</h6>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="grid">
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Job description</strong>
//                       <div className="inner-html" style={{paddingLeft:"17px"}} dangerouslySetInnerHTML={{ __html: currentItem.description }} />
//                     </div>
//                   </div>
//                   <div className="sm:py-4 sm:px-2 py-8 px-7">
//                     <div className="relative z-0 mb-2 w-full group">
//                       <strong>Termination condition</strong>
//                       <div className="inner-html" style={{paddingLeft:"17px"}} dangerouslySetInnerHTML={{ __html: currentItem.terminationCondition }} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
//                 <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setJobsView(false)}>
//                   {t("O_BACK")}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//       <div className="opacity-25 fixed inset-0 z-40 bg-black" />
//     </>
//   );
// };

// export default ManageView;
